import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignIn from "../pages/Auth/SignIn";
import SignUp from "../pages/Auth/SignUp";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import Dashboard from "../pages/Home/Dashboard/Dashboard";
import PublicRoute from "../utils/services/PublicRoute";
import PrivateRoute from "../utils/services/PrivateRoute";
import Events from "../pages/Home/Events/Events";
import Forum from "../pages/Home/Forum/Forum";
import Groups from "../pages/Home/Groups/Groups";
import Messages from "../pages/Home/Messages/Messages";
import EventDetails from "../pages/Home/Events/EventDetails";
import MyProfile from "../pages/Home/Profile/MyProfile/MyProfile";
import OthersProfile from "../pages/Home/Profile/OthersProfile/OthersProfile";
import AdminPosts from "../pages/Admin/AdminPosts/AdminPosts";
import AdminPhotoGallery from "../pages/Admin/AdminPhotoGallery/AdminPhotoGallery";
import AdminDocuments from "../pages/Admin/AdminDocuments/AdminDocuments";
import AdminAboutMe from "../pages/Admin/AdminAboutMe/AdminAboutMe";
import AdminEditPost from "../pages/Admin/AdminEditPost/AdminEditPost";
import LandingHome from "../pages/Landing/LandingHome/LandingHome";
import LandingPosts from "../pages/Landing/LandingPosts/LandingPosts";
import LandingPostDetails from "../pages/Landing/LandingPostDetails/LandingPostDetails";
import LandingGallery from "../pages/Landing/LandingGallery/LandingGallery";
import LandingDocuments from "../pages/Landing/LandingDocuments/LandingDocuments";
import LandingAboutMe from "../pages/Landing/LandingAboutMe/LandingAboutMe";
import { useDispatch } from "react-redux";
import { setFunctions } from "../utils/config/config";

const AppRouter = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setFunctions(dispatch);
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/home" element={<LandingHome />} />
        <Route path="/posts" element={<LandingPosts />} />
        <Route path="/posts/post-details" element={<LandingPostDetails />} />
        <Route path="/gallery" element={<LandingGallery />} />
        <Route path="/documents" element={<LandingDocuments />} />
        <Route path="/about-me" element={<LandingAboutMe />} />

        <Route element={<PublicRoute />}>
          <Route path="/" element={<LandingHome />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/event-details" element={<EventDetails />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/groups" element={<Groups />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/profile/me" element={<MyProfile />} />
          <Route path="/profile/:id" element={<OthersProfile />} />
          <Route path="/admin/posts" element={<AdminPosts />} />
          <Route
            path="/admin/posts/edit-post"
            element={<AdminEditPost />}
          />
          <Route path="/admin/gallery" element={<AdminPhotoGallery />} />
          <Route path="/admin/documents" element={<AdminDocuments />} />
          <Route path="/admin/about-me" element={<AdminAboutMe />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
